import SamplePageContainer from "../../../Components/Pages/SamplePage/SamplePageContainer";

const SamplePage = () => {
  return <SamplePageContainer />;
};

export default SamplePage;
